<mat-card-title style="font-family: 'Inter'; color: #2A3654; font-weight: 400; margin-bottom: 20px; font-size: 24px; display: flex;">Dashboard</mat-card-title>



<div class="dashboard-container">
  <div class="project-section">
    <mat-card>
      <div style="justify-content: space-between;text-align: center; align-items: center ;display: flex;">
          <mat-card-title  style="padding-left: 10px;">
          <span class="main-box-title-16">Projects</span>
          <div class="tooltip-container">
            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
            <span class="tooltip-text">We take security seriously. All of your projects are strictly private, and can only be seen by you unless you choose to share them. Deleting a project will clear it from our servers completely.</span>
          </div>
          
          </mat-card-title>
          <button mat-button class="new-project-btn" [disabled]="isThereManyProjects" (click)="newAnalysis()">New Analysis</button>
      </div>

       <div *ngIf="!loaderActive && isThereManyProjects" class="message">
        <div class="line"></div>
        <p>You have reached your project limit (10). <br> To create another, please delete or modify an existing project.</p>
      </div>

      <div *ngIf="loaderActive" class="loader-container">
        <div class="loader"></div> 
      </div>

      <div *ngIf="!loaderActive" id="div_table_project">
        <table mat-table [dataSource]="paginatedProjects" class="mat-elevation-z8">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef style="text-align: left;"> Project Name </th>
            <td mat-cell *matCellDef="let project" class="project-name-cell"> {{project.name}} </td>
          </ng-container>

          <ng-container matColumnDef="wordCount">
            <th mat-header-cell *matHeaderCellDef>Word Count </th>
            <td mat-cell *matCellDef="let project"> {{project.wordCount}} </td>
          </ng-container>

          <ng-container matColumnDef="sections">
            <th mat-header-cell *matHeaderCellDef>Number of Texts   </th>
            <td mat-cell *matCellDef="let project"> {{project.sections}} </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date Created </th>
            <td mat-cell *matCellDef="let project"> {{project.creation | date:'dd/MM/yy'}} </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let project" class="bottoms-cell">
              <button style="background-color: #F3F3F5; border: none;" (click)="editProject(project)">
                <img class="img-logos btn-edit" src="./assets/images/edit-icon-yellow.svg">
              </button>
              <!-- <button  style="background-color: #F3F3F5; border: none;" (click)="shareProject(project)">
                <img class="img-logos" src="./assets/images/share-icon.svg">
              </button> -->
              <button style="background-color: #F3F3F5; border: none;" (click)="deleteProject(project)">
                <img class="img-logos btn-delete" src="./assets/images/delete-icon.svg">
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <!-- Paginador -->
      <div class="pagination-container">
        <ul class="pagination">
          <li><img style="padding-bottom: 8px;" (click)="prevPageProjects()"  src="./assets/images/dropdow-Icon-left.svg"></li>
          <li *ngFor="let page of pagesProjects" [ngClass]="{'active': page === currentPageProjects}">
            <a href="#" (click)="goToPageProjects(page)">{{ page }}</a>
          </li>
          <li><img style="padding-bottom: 8px;" (click)="nextPageProjects()"  src="./assets/images/dropdow-Icon-right.svg"></li>
        </ul>
      </div>
     
    </mat-card>
  </div>

  <div class="wordlist-section">
    <mat-card>
      <div style="justify-content: space-between;text-align: center; align-items: center ;display: flex;">
          <mat-card-title >
          <span class="main-box-title-16" >Known word lists</span> 
          <div class="tooltip-container">
            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
            <span class="tooltip-text">
              You can create a new set of 'known words' which will be ignored in analysis. This is particularly useful if your text is domain-specific, and certain specific terminology is overrepresented compared to the normal population. For example, if you are teaching a group of doctors who will be more familiar with complex medical terms than the average person.
            </span>
          </div>
          </mat-card-title>
          <button mat-button class="new-list-btn" (click)="createList()">New List</button>
      </div>

      <div *ngIf="loaderActive" class="loader-container">
        <div class="loader"></div> 
      </div>

      <div *ngIf="!loaderActive" id="div_table_project">
        <table mat-table [dataSource]="paginatedWordLists" class="mat-elevation-z8 custom-table">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef style="text-align: left;"> List Name </th>
            <td mat-cell *matCellDef="let list" class="project-name-cell"> {{list.name}} </td>
          </ng-container>

          <ng-container matColumnDef="wordCount">
            <th mat-header-cell *matHeaderCellDef> Word Count </th>
            <td mat-cell *matCellDef="let list"> {{list.wordCount}} </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef> Date Created </th>
            <td mat-cell *matCellDef="let list"> {{list.date | date:'dd/MM/yy'}} </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let list"class="bottoms-cell">
              <button style="background-color: #F3F3F5; border: none;" (click)="editWordList(list)">
                <img class="img-logos btn-edit" src="./assets/images/edit-icon-yellow.svg">
              </button>
              <button  style="background-color: #F3F3F5; border: none;" (click)="deleteList(list)">
                <img class="img-logos btn-delete" src="./assets/images/delete-icon.svg">
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsWordList"></tr>
          <tr mat-row class="clase" *matRowDef="let row; columns: displayedColumnsWordList;"></tr>
        </table>
      </div>
      <!-- Paginador -->
      <div class="pagination-container">
        <ul class="pagination">
          <li><img style="padding-bottom: 8px;" (click)="prevPageWordLists()"  src="./assets/images/dropdow-Icon-left.svg"></li>
          <li *ngFor="let page of pagesWordLists" [ngClass]="{'active': page === currentPageWordLists}">
            <a href="#" (click)="goToPageWordLists(page)">{{ page }}</a>
          </li>
          <li><img style="padding-bottom: 8px;" (click)="nextPageWordLists()"  src="./assets/images/dropdow-Icon-right.svg"></li>
        </ul>
      </div>
    </mat-card>
  </div>
  
</div>
